var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-screen" },
    [
      _c("panel-toolbar"),
      _c(
        "b-skeleton-wrapper",
        {
          attrs: { loading: _vm.loadingWallet },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function () {
                return [
                  _c(
                    "hb-section",
                    [
                      _c("b-skeleton-img", {
                        attrs: { "no-aspect": "", height: "180px" },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.walletError
            ? _c("section-error", {
                attrs: { message: _vm.walletError },
                on: { retry: _vm.loadWallet },
              })
            : _vm.balances
            ? _c("wallet-summary-card", {
                attrs: { balances: _vm.balances, upcoming: _vm.upcoming },
                on: { withdraw: _vm.openWithdraw },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("hb-tabs", {
        attrs: { value: _vm.tab, tabs: _vm.tabs },
        on: { input: _vm.changeTab },
      }),
      _vm.tab === "extrato"
        ? [
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingEntries },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "loading",
                      fn: function () {
                        return [
                          _c(
                            "hb-section",
                            [
                              _c("b-skeleton-img", {
                                attrs: { "no-aspect": "", height: "200px" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1379530281
                ),
              },
              [
                _vm.entriesError
                  ? _c("section-error", {
                      attrs: { message: _vm.entriesError },
                      on: { retry: _vm.loadEntries },
                    })
                  : _c("statement-pane", {
                      attrs: {
                        entries: _vm.entries,
                        totals: _vm.entryTotals,
                        type: _vm.entryType,
                        "current-page": _vm.page,
                        "last-page": _vm.lastPage,
                        total: _vm.totalEntries,
                        "per-page": _vm.perPage,
                      },
                      on: {
                        "update:type": _vm.changeEntryType,
                        "update:page": _vm.changePage,
                      },
                    }),
              ],
              1
            ),
          ]
        : _vm.tab === "saques"
        ? [
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingWithdrawals },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [
                        _c(
                          "hb-section",
                          [
                            _c("b-skeleton-img", {
                              attrs: { "no-aspect": "", height: "200px" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.withdrawalsError
                  ? _c("section-error", {
                      attrs: { message: _vm.withdrawalsError },
                      on: { retry: _vm.loadWithdrawals },
                    })
                  : _c("withdrawals-pane", {
                      attrs: { withdrawals: _vm.withdrawals },
                      on: {
                        request: _vm.openWithdraw,
                        cancel: _vm.confirmCancel,
                        receipt: _vm.downloadReceipt,
                      },
                    }),
              ],
              1
            ),
          ]
        : [
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingPix },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [
                        _c(
                          "hb-section",
                          [
                            _c("b-skeleton-img", {
                              attrs: { "no-aspect": "", height: "160px" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.pixError
                  ? _c("section-error", {
                      attrs: { message: _vm.pixError },
                      on: { retry: _vm.loadPixKeys },
                    })
                  : _c("pix-keys-pane", {
                      attrs: { keys: _vm.pixKeys },
                      on: {
                        create: function ($event) {
                          return _vm.$refs.pixForm.open()
                        },
                        "set-default": _vm.setDefaultPixKey,
                        remove: _vm.confirmRemovePixKey,
                      },
                    }),
              ],
              1
            ),
          ],
      _c("withdrawal-request-modal", {
        ref: "withdraw",
        attrs: {
          "max-cents": _vm.balances ? _vm.balances.withdrawable : 0,
          "pix-keys": _vm.pixKeys,
        },
        on: { confirm: _vm.requestWithdrawal },
      }),
      _c("pix-key-form-modal", {
        ref: "pixForm",
        on: { save: _vm.savePixKey },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }